import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        style: {
          fontFamily: "'Noto Sans', system-ui, sans-serif",
          borderRadius: '10px',
          fontSize: '15px',
        },
      }}
    />
  );
}
